/**
 * Startup Contents Data Models
 * Represents the structure of data returned from the GraphQL startupContents query
 */

export const userInfoModel = {
    id: "",
    name: "",
    group: "",
    education: null,
    email: "",
    active: null,
    isEmailVerified: false
};

export const userSubscriptionModel = {
    id: "",
    userId: "",
    subscriptionType: "Basic", // "Basic" or "Premium" or others
    startDate: "",
    endDate: "",
    isActive: false,
    isTrial: false
};

export const featureToggleModel = {
    userId: "",
    paragraphGenerator: false,
    paragraphScanner: false,
    freeBooks: false,
    booksOnDemand: false
};

export const booksBySubscriptionModel = [
    {
        id: "",
        title: "",
        author: "",
        level: "",
        imageUrl: "",
        categories: null,
        ratings: null,
        availability: ""
    }
];

export const applicationLinksModel = {
    privacyPolicy: "",
    termsAndConditions: "",
    subscription: "",
    bookStore: ""
};

export const appSupportContactsModel = {
    generalQuestions: {
        phone: "",
        email: ""
    },
    customerSupport: {
        phone: "",
        email: ""
    },
    billingAndPayments: {
        phone: "",
        email: ""
    }
};

export const readingAssessmentModel = {
    isOnBoardingAssessmentSubmitted: false
};

export const learnAboutFeatureModel = {
    featureKey: "",
    pageName: "",
    title: "",
    message: "",
    content: [
        {
            id: "",
            paragraph: ""
        }
    ],
    actions: [
        {
            type: "",
            target: "",
            description: ""
        }
    ],
    cta: {
        label: "",
        deepLink: ""
    }
};

export const featureUsageModel = {
    featureKey: "",
    isUsed: false
};

export const startupContentsModel = {
    userInfo: userInfoModel,
    userSubscription: userSubscriptionModel,
    featureToggle: featureToggleModel,
    booksBySubscription: booksBySubscriptionModel,
    applicationLinks: applicationLinksModel,
    appSupportContacts: appSupportContactsModel,
    readingAssessment: readingAssessmentModel,
    learnAboutFeature: learnAboutFeatureModel,
    featureUsage: featureUsageModel
};
